<template>
  <div class="bg-gray-900 rounded-lg shadow-lg text-text-primary text-sm">
    <!-- Team Label for Mobile -->
    <div class="py-4 px-3 text-text-secondary text-xs lg:hidden w-full bg-gray-900 rounded-t-lg" v-html="teamLabel" />

    <!-- Desktop Table -->
    <table class="w-full text-right hidden lg:table">
      <thead>
        <tr class="text-sm text-text-secondary whitespace-nowrap">
          <th class="py-4 px-4 font-light text-left w-1/3" v-html="teamLabel" />
          <StatTableHeader
            v-for="column in columns"
            :key="column.key"
            :column="column"
            :sort-column="sortColumn"
            :sort-direction="sortDirection"
            @sort="$emit('sort', $event)"
          />
        </tr>
      </thead>
      <tbody>
        <PlayerRow
          v-for="(player, index) in players"
          :key="index"
          :player="player"
          :columns="columns"
          :platform="platform"
          :match-type="matchType"
          :cs-map="csMap"
          :current-user-id="currentUserId"
        />
      </tbody>
    </table>

    <!-- Mobile Cards -->
    <div class="lg:hidden">
      <PlayerRow
        v-for="(player, index) in players"
        :key="index"
        :player="player"
        :columns="columns"
        :platform="platform"
        :match-type="matchType"
        :cs-map="csMap"
        :current-user-id="currentUserId"
      />
    </div>
  </div>
</template>

<script setup>
import StatTableHeader from './StatTableHeader.vue';
import PlayerRow from './PlayerRow.vue';

const props = defineProps({
  players: {
    type: Array,
    required: true,
  },
  columns: {
    type: Array,
    required: true,
  },
  teamLabel: {
    type: String,
    required: true,
  },
  sortColumn: {
    type: String,
    default: null,
  },
  sortDirection: {
    type: String,
    default: 'desc',
  },
  platform: {
    type: String,
    required: true,
  },
  matchType: {
    type: String,
    required: true,
  },
  csMap: {
    type: String,
    required: true,
  },
  currentUserId: {
    type: String,
    default: null,
  },

});

const emit = defineEmits(['sort']);
</script>
